import { ShopProdotti } from "./ShopProdotti";
import { TabellaProdotti } from "./TabellaProdotti";
import { RichiesteProdotti } from "./RichiesteProdotti";

export const Vendita = {
  ShopProdotti: ShopProdotti,
  TabellaProdotti: TabellaProdotti,
  RichiesteProdotti: RichiesteProdotti,
};
